import React from "react";
import { Link } from "react-router-dom";
import { Tv, Zap, ChevronRight, Phone, Mail, Sparkles } from "lucide-react";

export default function TemplateVibrant({ site }) {
  const { brand_name, color_primary, color_accent, color_nav, phone, email, products, headline, tagline } = site;
  const p = color_primary || "#f43f5e"; // rose-500
  const a = color_accent || "#f59e0b"; // amber-500
  const n = color_nav || "#0f172a"; // slate-900

  return (
    <div className="min-h-screen font-body">
      {/* Nav */}
      <nav style={{ background: `linear-gradient(to right, ${p}, ${a})` }} className="text-white">
        <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
          <span className="font-heading font-bold text-xl flex items-center gap-2"><Sparkles className="w-5 h-5" />{brand_name || "DTH Portal"}</span>
          <Link to="login" style={{ color: p }} className="bg-white px-4 py-2 rounded-full text-sm font-bold hover:shadow-lg inline-block text-center">Login</Link>
        </div>
      </nav>

      {/* Hero */}
      <section style={{ background: `linear-gradient(to bottom right, ${p}, ${a})` }} className="text-white py-24 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-heading font-black text-5xl md:text-7xl">{headline || "🎬 Unlimited Entertainment"}</h1>
          <p className="mt-4 text-white/80 text-lg">{tagline || "Recharge your DTH instantly. Best prices. Best service. Best channels."}</p>
          <button style={{ color: p }} className="mt-8 bg-white px-8 py-4 rounded-full font-bold text-lg hover:shadow-xl transition-shadow flex items-center gap-2 mx-auto">
            <Zap className="w-5 h-5" /> Recharge Now
          </button>
        </div>
      </section>

      {/* Plans */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading font-bold text-3xl text-center text-slate-800">🔥 Hot Plans</h2>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {(products || []).slice(0, 6).map((p_item, i) => (
              <div key={p_item.id || i} className="rounded-2xl p-6 bg-slate-50 border-2 border-transparent hover:shadow-xl transition-all" style={{ '--tw-border-opacity': '1' }} onMouseEnter={(e) => e.currentTarget.style.borderColor = p} onMouseLeave={(e) => e.currentTarget.style.borderColor = 'transparent'}>
                <p style={{ color: p }} className="text-xs uppercase font-bold">{p_item.category || p_item.operator}</p>
                <h3 className="font-heading font-bold text-xl text-slate-800 mt-1">{p_item.name}</h3>
                <p style={{ color: p }} className="font-heading font-black text-4xl mt-3">₹{p_item.sell_price}</p>
                <p className="text-sm text-slate-500 mt-1">{p_item.validity_days} days</p>
                <button style={{ background: `linear-gradient(to right, ${p}, ${a})` }} className="mt-4 w-full text-white py-3 rounded-xl font-bold hover:shadow-lg transition-all">
                  Get This Plan
                </button>
              </div>
            ))}
          </div>
          {(!products || products.length === 0) && <p className="text-center text-slate-400 mt-8">Plans coming soon!</p>}
        </div>
      </section>

      {/* Footer */}
      <footer style={{ backgroundColor: n }} className="text-white py-8 px-4">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <span className="font-heading font-bold">{brand_name}</span>
          <div className="flex gap-4 text-sm text-white/60">
            {phone && <span className="flex items-center gap-1"><Phone className="w-4 h-4" />{phone}</span>}
            {email && <span className="flex items-center gap-1"><Mail className="w-4 h-4" />{email}</span>}
            <Link to="privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
          </div>
        </div>
        <div className="max-w-6xl mx-auto mt-8 pt-4 border-t border-white/20 text-center text-xs text-white/60">
          Powered by : Oxiaim Techbreed Pvt. Ltd.
        </div>
      </footer>
    </div>
  );
}
